<div class="col-md-8 col-md-offset-2">
  <form>
    <label class="form-group col-md-12" style="padding-top: 1em;">
      <select name="reason" class="form-control" (change)="validateDataToSendSms()" [(ngModel)]="reasonId" style="text-transform: uppercase;color: darkgrey;font-size: 14px;">
        <option value="0">{{ 'selectReason' | translate }}</option>
        <option *ngFor="let r of reasonList" value="{{r.pk_reasonId}}">{{r.reason}}</option>
      </select>
    </label>
    <div class="form-group col-md-12">
      <textarea class="form-control" maxlength="120" [placeholder]="'typeYourMessageHere' | translate" (keyup)="validateDataToSendSms()" [(ngModel)]="message" name="message" rows="3" style="color: darkgrey;font-size: 14px;"></textarea>
    </div>
    <div class="col-md-12">
      <span style="margin-top: -20px;font-size: 11px;float: right;color: darkgrey;">{{messageLength}} {{ 'charactersRemains' | translate }}</span>
      <button *ngIf="allowToSendMessage" type="button" (click)="getSmsData()" class="btn btn-raised ink-reaction btn-info" data-toggle="modal" data-target="#smsAlertModel" aria-expanded="true">{{ 'sendMessage' | translate }}</button>
      <button *ngIf="!allowToSendMessage" type="button" (click)="validateSmsData()" class="btn btn-raised ink-reaction btn-info" aria-expanded="true">{{ 'sendMessage' | translate }}</button>
    </div>
  </form>
</div>

<!--SMS ALERT MODAL BOX-->

<div class="modal fade" id="smsAlertModel" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="row">
        <div class="col-md-12 text-center" style="margin-top: 2em">
          <img src="../../images_ext/exclamation.png">
        </div>
        <div class="col-md-12 text-center" style="padding: 1em 4em;color: gray;">
          <h2 *ngIf="!canSendSms" style="font-size: 1.1em;font-weight: 700;color: darkgray;">{{ 'youWon'tBeAbleToSendThisMessageBecauseOnly' | translate }} {{remainingSms}} {{ 'smsIsRemainingSelectedSmsRecipientsMustBeLessThanOrEqualToRemainingSms' | translate }}</h2>
          <h4 *ngIf="!canSendSms" style="font-weight: 900;">{{ 'pleaseRequestToPurchaseSms' | translate }}</h4>
          <h2 *ngIf="canSendSms" style="font-size: 1.1em;font-weight: 700;color: darkgray;">{{ 'thisMessageWillConsume' | translate }} {{user_count}} {{ 'smsOutOf' | translate }} {{remainingSms}} {{ 'smsRemainingAfterSending' | translate }} {{leftSms}} {{ 'smsLeft' | translate }}</h2>
          <h4 *ngIf="canSendSms" style="font-weight: 900;">{{ 'areYouSure' | translate }}</h4>
          <h5 *ngIf="canSendSms" style="font-size: 1.1em;font-weight: 700;color: darkgray;">{{ 'youWantToProceed' | translate }}</h5>
        </div>
        <div class="col-md-12 text-center" style="padding-top: 15px;margin-bottom: 2em;">
          <button *ngIf="canSendSms" (click)="sendMessageOption()" class="btn btn-raised ink-reaction btn-info" [disabled]="messageSending" type="button"><span *ngIf="!messageSending">{{ 'yesPleaseProceed' | translate }}</span><span *ngIf="messageSending">{{ 'pleaseWait' | translate }}</span></button>
          <button class="btn btn-raised ink-reaction btn-info" data-dismiss="modal" [disabled]="messageSending" type="button">{{ 'cancel' | translate }}</button>
          <button class="btn btn-raised ink-reaction btn-info" id="cancelSendMessage" data-dismiss="modal" type="button" style="display: none;">{{ 'cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
